import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import { TIKTOK_REDIRECT_URL_PARAMS } from '../../../../config/constants/aggregators';
import { PROVIDER_ROUTE } from '../../../../config/constants/routes';
import { isEmpty } from '../../../../utils';
import { useInjectReducer } from '../../../../utils/injectReducer';
import { useInjectSaga } from '../../../../utils/injectSaga';
import localStorage from '../../../../utils/localStorage';
import { getSettings } from '../../actions';
import reducer from '../../reducer';
import saga from '../../saga';
import { AGGREGATORS } from '../../sagaMap';

function TiktokRedirect({ getAuthCallback }) {
  useInjectReducer({ key: 'integration', reducer });
  useInjectSaga({ key: 'integration', saga });

  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location?.search);
  const code = searchParams.get(TIKTOK_REDIRECT_URL_PARAMS.CODE);
  const ttsInfo = localStorage.getItem('tts_info');
  const {
    business_id: businessId = null,
    branch_id: branchId = null,
    brand_id: brandId = null,
    login_url: loginUrl = null,
  } = ttsInfo || {};

  const state = (() => {
    if (searchParams.has(TIKTOK_REDIRECT_URL_PARAMS.STATE)) {
      return searchParams.get(TIKTOK_REDIRECT_URL_PARAMS.STATE);
    }
    if (!isEmpty(loginUrl)) {
      const loginSearchParams = new URLSearchParams(new URL(loginUrl).search);
      return loginSearchParams.get(TIKTOK_REDIRECT_URL_PARAMS.STATE);
    }
    return null;
  })();

  useEffect(() => {
    if (!isEmpty(state) && !isEmpty(code)) {
      const { url } = AGGREGATORS.TIKTOK.AUTH_CALLBACK;

      const backToProviders = () => {
        navigate(
          `${PROVIDER_ROUTE}?business_id=${businessId}&brand_id=${brandId}&branch_id=${branchId}&open_tts=true`,
        );
      };

      const payload = {
        params: {
          state,
          code,
        },
        url,
        callbackFn: () => {
          backToProviders();
        },
        failCallbackFn: () => {
          backToProviders();
        },
      };
      getAuthCallback(payload);
    }
  }, [code, state]);

  return <div className="text-xl">Redirecting...</div>;
}

TiktokRedirect.propTypes = {
  getAuthCallback: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    getAuthCallback: params => dispatch(getSettings(params)),
  };
}

const withConnect = connect(null, mapDispatchToProps);
export default compose(withConnect)(TiktokRedirect);
